import React, { useEffect, useId, useMemo, useRef, useState } from "react";
import { WMSSelect } from "../../widgets/selectbox";
import { WMSInput } from "../../widgets/input";
import CustomTable from "../table/customTable";
import { Button, Modal } from "react-bootstrap";
import { createColumnHelper } from "@tanstack/react-table";
import { useLocation, useNavigate } from "react-router-dom";
import { invokePostService, invokeGetService } from "../../service";
import { apiUrl } from "../../base/utils";
import { connect } from "react-redux";
import WHSLoader from "../../widgets/loader";

import { toastError, toastSuccess, toastWarning } from "../../widgets/toaster";
import axios from "axios";
import { config } from "../../config";
import DraggableComponent, {
  RowDragHandleCell,
} from "../table/customTable/DraggableComponent";
import HOCAutoLogout from "../autologout";
import WHSEtwoELoader from "../../widgets/loader/etwoeLoader";

interface Option {
  value: string;
  label: string;
}

interface Data {
  id: number;
  checkbox: any;
  sequenceorder: number;
  articleid: string;
  articlename: string;
  articletitle: string;
  articletype: string;
  articlecategory: string;
  moveddate: string;
  createddate: string;
  dueDate: string;
  name: string;
  filename: string;
  actions: any;
  stage: string;
  value: any;
  isDraggable: boolean;
  ismovedtoproduction: boolean;
  is_moved_to_production: string;
  newsequence: number;
  articletitlename: string;
}

function MoveArticle(props: any) {
  const location = useLocation();
  const state = location.state || {};

  const [journals, setJournal] = useState([]);
  const [journalsvalue, setJournalsvalue] = useState<any>(
    state?.journalsvalue || ""
  );
  const [journalId, setJournalId] = useState("");
  const [openSupplement, setOpenSupplement] = useState<any>(false);
  const [isdisabled, setisdisabled] = useState(
    !(journalsvalue?.id || state?.journalsvalue?.id)
  );
  const [issue, setIssue] = useState([]);
  const [issuesvalue, setIssuesvalue] = useState<any>(state?.issuesvalue || "");
  const [issueId, setissueId] = useState("");
  const [assignee, setAssignee] = useState("Integra");
  const [allocatedtableData, setallocatedtableData] = useState<any[]>([]);
  const [unAllocatedTableData, setUnAllocatedTableData] = useState([]);
  const [sublementtableData, setsublementtableData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isEtwoELoader, setIsEtwoELoader] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileData, setFileData] = useState("");
  const [fileerror, setExtention] = useState("");
  const [filesize, setFilesize] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [isShow1, setIsShow1] = useState(false);
  const [allocatedRowData, setAllocatedRowData] = useState<any>("");
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [filteredUnAllocatedTableData, setFilteredUnAllocatedTableData] =
    useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [journalPrefix, setJournalPrefix] = useState(
    state?.journalPrefix || ""
  );
    const [editionInfo1, setEditionInfo1] = useState(state?.editionInfo || "");

  const [issueNumber, setIssueNumber] = useState(state?.issueNumber || "");
  const [editionInfo, setEditionInfo] = useState(state?.editionInfo || "");
  const [filteredUnAllocatedData, setFilteredUnAllocatedData] = useState([]);
  const [fileTipShow, setFileTipShow] = useState(false);
  const [isTableDisabled, setIsTableDisabled] = useState(false);
  const [msComplete, setMsComplete] = useState(false);
  const navigate = useNavigate();
  const allocatedKey = useId();
  const unallocatedKey = useId();
  // const [count, setCount] = useState(0);
  const selectedValuesRef = useRef(
    allocatedtableData.map((row) => row.articletype || options[0].value)
  );
  const [rowData, setRowData] = useState([]);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [isRender, setRender] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<Map<string, string>>(new Map()); // Map to track filenames and base names

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleDelete = () => {
    setFileName("");
    setFileData("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setShowModal(false);
  };

  const handleCancelAction = () => {
    if (journalId || fileData) {
      setShowCancelModal(true);
    }
  };

  const getjournallist = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getAllJournalsByUserId;
      setIsLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        { userid: props?.userInfo?.userid },
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      let data: any = [];
      response.data.data.result.map((list: any) => {
        data.push({ value: list.code, label: list.code, id: list.journalid });
      });
      setJournal(data);
    } catch (error) { }
  };

  const checkFileCorruption = async (files: any) => {
    const reader = new FileReader();
    // Read a portion of the file (e.g., the first 100 bytes)
    const chunkSize = 100;
    const blob = files[0].slice(0, chunkSize);
    reader.readAsArrayBuffer(blob);
    reader.onload = () => {
      // File read successfully, no corruption detected
      return true;
    };
    reader.onerror = () => {
      // Error occurred during file reading, indicating possible corruption
      setExtention("File is corrupted or cannot be read.");
      return false;
    };
    return true;
  };

  const validateFields = async (e: any) => {
    const maxFileSize = 50 * 1024 * 1024; // 10 MB in bytes
    const file = e.target.files[0];
    const fileSize = file.size;
    const fileName = file.name;

    const formatFileSize = (size: number) => {
      if (size >= 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + " MB";
      } else if (size >= 1024) {
        return (size / 1024).toFixed(2) + " KB";
      } else {
        return size + " bytes";
      }
    };

    if (fileSize > maxFileSize) {
      setExtention(
        `File size exceeds the maximum allowed size (50 MB). Your file size: ${formatFileSize(
          fileSize
        )}`
      );
      return false;
    }

    if (fileSize <= 0) {
      setExtention(`${fileName}'s size is 0 KB. Please choose a valid file.`);
      return false;
    }

    return true;
  };

  const saveIssueArticleDetails = async (articles: any[]) => {
    try {

      let url = apiUrl.nodeApi.insertIssueArticleDetails;
      console.log(articles,"articles")
      const payload = articles.map((article) => ({
        journalid: journalId || state.journalId,
        issueid: issueId || state.issueId,
        articleid: article.articleid,
        movedby: props?.userInfo?.userid,
        moveddate: new Date(article.moveddate),
        articlecategory: article.articletype,
        sequenceorder: article.sequenceorder,
        duedate: new Date(article.dueDate),
        articletitlename: article.articletitlename
      }));
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (response?.data?.message !== "Draft saved successfully") {
        throw new Error(response?.data?.message);
      }
      await getAllocatedList();
      return response?.data?.message;
    } catch (error) {
      toastError(`${error}`);
      setIsLoader(false);
    }
  };

  const handlesearch = (e: any) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query === "") {
      setFilteredUnAllocatedTableData(unAllocatedTableData);
    } else {
     let filterColumns = ["articlename", "articletype", "createddate"].map(col => col.toLowerCase());

const datePattern = /^\d{2}-\d{2}-\d{4}$/;
let formattedDate = "";

if (datePattern.test(query)) {
  const [day, month, year] = query.split("-");
  formattedDate = `${year}-${month}-${day}`; // e.g., "2024-06-09"
}

const filteredData = unAllocatedTableData.filter((item: any) => {
  return filterColumns.some(column => {
    const value = item[column];
    if (!value) return false;

    if (column === "createddate") {
      const dbDateOnly = value.split(" ")[0]; // only "YYYY-MM-DD"
      if (formattedDate) {
        return dbDateOnly === formattedDate; // match exact date
      } else {
        // generic query match ONLY inside date part, not time
        return dbDateOnly.includes(query);
      }
    }

    return String(value).toLowerCase().includes(query.toLowerCase());
  });
});

setFilteredUnAllocatedTableData(filteredData);

    }
  };

  const getissuelist = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getAllIssueByJournalId;
      let payload = {
        journalid: journalId || state.journalId,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);

      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }

      let data = response.data.data.result.map((list: any) => {
        const [journalPrefix, issueNumber, editionInfo] =
          list.issuename?.split(/[_()]/);

        return {
          value: list.issuename,
          label: list.issuename,
          id: list.id,
          journalPrefix,
          issueNumber,
          editionInfo,
        };
      });

      setIssue(data);
    } catch (error) {
      console.error("Error fetching issue list:", error);
    }
  };

  const getsublementoryfiles = async (articleid: any) => {
    try {
      let url = apiUrl.nodeApi.getSupplementFilesByArticleId;
      let payload = {
        articleid: articleid,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      setsublementtableData(response.data.data.result);
    } catch (error) { }
  };

  const deletesublementoryfiles = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.deleteSupplementaryFile;
      let payload = {
        id: item.id,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      toastSuccess("Record Deleted Successfully");
      await getsublementoryfiles(item?.articleid);
    } catch (error) {
      toastError(`${error}`);
    }
  };

  const allowedFileTypes = [
    ".pdf",
    ".zip",
    ".tif",
    ".tiff",
    ".gif",
    ".jpg",
    ".jpeg",
    ".png",
    ".doc",
    ".xlsx",
    ".docx",
  ];

  const uploadFile = async (e: any, type: any, key: any) => {
    setIsLoader(true); // Show loader when starting file upload
    try {
      let filename = e && e.target.files[0] && e.target.files[0].name;
      let file = e && e.target.files[0];
      let filesize = file && file.size;

      setFilesize(filesize); // Set filesize state for display or further validation

      // Check if a file is selected
      if (!file) {
        toastError("No file selected");
        return;
      }
      const baseFilename = filename.slice(0, filename.lastIndexOf("."))?.toLowerCase();

      // Check if the base filename already exists
      if (uploadedFiles.has(baseFilename)) {
        toastError("A file with the same name already exists");
        return;
      }
      // Get file extension and validate against allowed types
      const fileExtension = filename
        .slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2)
        ?.toLowerCase();

      if (!allowedFileTypes.includes(`.${fileExtension}`)) {
        setExtention("Please upload a file in the correct format");
        toastError("Please upload a file in the correct format");
        return;
      }

      // Validate file size
      if (filesize <= 0) {
        toastError("File size should be greater than 0 KB");
        return;
      }

      if (filesize > 50 * 1024 * 1024) {
        toastError("File size should not exceed 50 MB");
        return;
      }

      // Additional validation if needed (validateFields and checkFileCorruption)
      if (await validateFields(e)) {
        if (await checkFileCorruption(e.target.files)) {
          setUploadedFiles(prev => new Map(prev).set(baseFilename, filename));
          // If all checks pass, set file details states
          setExtention(""); // Clear any previous extension error
          setFileName(filename); // Set the filename state
          setFileData(e.target.files[0]); // Set the file data state
        } else {
          toastError("File is corrupted or invalid.");
        }
      } else {
        toastError("Validation failed. Please check your inputs.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toastError("An error occurred while uploading the file.");
    } finally {
      setIsLoader(false); // Hide loader in all cases (success or failure)
    }
  };

  const uploadArticle = async () => {
    return new Promise(async (resolve, reject) => {
      const formData = new FormData();
      let autoName = Math.floor(Math.random() * 900000) + 100000;
      formData.append("files", fileData);
      formData.append("filename", `${autoName}_manuscript`);
      formData.append("filesize", filesize);
      formData.append("userid", props?.userInfo?.userid);
      formData.append("journalid", allocatedRowData?.journalid);
      formData.append("articleid", allocatedRowData?.articleid);
        setIsLoader(true); // Show loader when starting file upload
      try {
       
        let url = apiUrl.nodeApi.insertSupplementFiles;
        const response = await axios.post(
          `${config.prapp.basURL}${url}`,
          formData,
          {
            headers: {
              authorization: `Bearer ${props.isToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // const response :any = await invokePostService(url,formData)
        if (!response.data.data.isSuccess) {
          throw new Error(response.data.data.Error);
        }
         setIsLoader(false); // Show loader when starting file upload
        toastSuccess("File uploaded successfully");
        setOpenSupplement({ open: false, row: null }); // <-- this is closing the modal
        setFileData("");
        setFileName("");
        await getsublementoryfiles(allocatedRowData?.articleid);
        resolve(response.data.data.result.articleid);
      } catch (error) {
        toastError(`${error}`);
        setFileData("");
        reject(error);
      }
    });
  };

  const downloadSubblementary = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.downloadSupplementoryFile;
      const queryParams = { id: item.id };
      setIsLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      if (response.data.data.isSuccess) {
        const newWindow = window.open(
          response.data.data.result.downloadUrl,
          "_blank"
        );
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          toastWarning(
            "Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'."
          );
        }
      }
    } catch (error) {
      toastError("The requested HTML file is not generated yet");
      setIsLoader(false);
    }
  };

  const pdfDetails = async (item: any) => {
    try {
      let showPop=true;
      let url = apiUrl.nodeApi.gethtmlDownloadByActivityId;
      const queryParams = { articleid: item.articleid };
      setIsLoader(true);
      const timer = setTimeout(() => {
        if (showPop) {
          toastWarning("Download in progress, Please wait for few Minutes.");
          showPop = false;
        }
        setIsLoader(false);
      }, 2000);
      const response: any = await invokePostService(
        url,
        queryParams,
        props.isToken
      );
      clearTimeout(timer);
      setIsLoader(false);
      console.log(response,"respon")
      if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
      if (response.data.data.isSuccess) {
        const link = document.createElement("a");
        link.href = response.data.data.result.downloadUrl;
        link.download = `${item.articleid}_report.html`; // Set proper filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      toastError("The requested HTML file is not generated yet");
      setIsLoader(false);
    }
  };

  const handleapprovedlist = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getEditorApprovedArticleList;
      let payload = {
        userid: props?.userInfo?.userid,
        journalid: journalId || state.journalId,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      // Adding id to each article
      const articlesWithId = response.data.data.result.map(
        (article: any, index: number) => ({
          ...article,
          id: index + 1,
        })
      );

      setUnAllocatedTableData(articlesWithId);
      setFilteredUnAllocatedTableData(articlesWithId);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllocatedList = async () => {
    try {
      let url = apiUrl.nodeApi.getIssueArticleByJournalIdAndIssueId;
      let payload = {
        journalId: journalId || state.journalId,
        issueid: issueId || state.issueId,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);

      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }

      const msComplete = response?.data?.data?.isMsComplete;
      setMsComplete(msComplete);

      const resultWithDueDate = response.data.data.result.map((item: any,index:number) => {
        const movedDate = new Date(item.moveddate);
        const dueDate = new Date(movedDate);
        dueDate.setDate(movedDate.getDate() + 5);
        return {
          ...item,
          sequenceorder: index+1,
          dueDate: dueDate.toISOString(),
          isDraggable: !item.ismovedtoproduction,
        };
      });

      setallocatedtableData(resultWithDueDate);
      setRowData(resultWithDueDate);
      const isComplete = resultWithDueDate.some(
        (item: any) => item.ismscomplete
      );
      setIsTableDisabled(isComplete);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getjournallist("journaltitle");
  }, []);

  useEffect(() => {
    if (journalId || state.journalId) {
      getissuelist("issue");
      setIsShow1(true);
      handleapprovedlist("unAllocatedTabledata");
    }
  }, [journalId, issueId]);

  useEffect(() => {
    if (issueId || state.issueId) {
      getAllocatedList();
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }, [issueId]);

  const handleFormSelection = (e: any, type: any) => {
    if (type === "journal") {
      setJournalsvalue(e);
      setJournalId(e.id);
      setIssuesvalue("");
      setissueId("");
      setallocatedtableData([]);
    } else {
      setIssuesvalue(e);
      setissueId(e.id);
      setJournalPrefix(e.journalPrefix);
      setIssueNumber(e.issueNumber);
      setEditionInfo(e.editionInfo);
    }
  };

  const columnHelper = createColumnHelper<Data>();

  const options: Option[] = useMemo(
    () => [
      { value: "Book Review", label: "Book Review" },
      { value: "Article", label: "Article" },
      { value: "Case study", label: "Case study" },
      { value: "Editorial", label: "Editorial" },
    ],
    []
  );

  useEffect(() => {
    selectedValuesRef.current = allocatedtableData.map(
      (row) => row.articletype || options[0].value
    );
  }, [allocatedtableData, options]);

  const handleArticleTypeChange = (index: number, value: any): void => {
    if (index < 0 || index >= allocatedtableData.length) {
      return;
    }

    // Update the allocatedtableData state
    const newAllocatedData = allocatedtableData.map((item, i) =>
      i === index ? { ...item, articletype: value } : item
    );
    setallocatedtableData(newAllocatedData);

    // Update selectedValues and selectedValuesRef
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    selectedValuesRef.current = newSelectedValues;
    setRender(true);
  };

  // const handleArticleTypeChange = (index: any, value: any) => {
  //   const newSelectedValues = [...selectedValues];
  //   newSelectedValues[index] = value;
  //   setSelectedValues(newSelectedValues);
  //   // Also update the corresponding allocatedtableData
  //   allocatedtableData[index].articletype = value;
  // };

  const handleDateChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const selectedDate = event.target.value;

    const newAllocatedData: any = [
      ...allocatedtableData.map((item: any, i: number) =>
        i === index ? { ...item, dueDate: selectedDate } : item
      ),
    ];

    setallocatedtableData(newAllocatedData);
  };

  const ArticleTypeCell = ({ row, handleArticleTypeChange, options }: any) => {
    const selectedValue = useRef(selectedValuesRef.current[row.index]);

    const handleSelectChange = (event: any) => {
      const newValue = event.target.value;
      handleArticleTypeChange(row.index, newValue);
    };

    return (
      <select
        className="form-control f-14"
        value={selectedValue.current}
        onChange={handleSelectChange}
      >
        {options.map((option: any) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  const allocatedColumns = useMemo(() => {
    return [
      columnHelper.display({
        id: "drag",
        header: "",
        cell: (props) => {
          // const isDraggable = props.row.original.isDraggable;
          console.log(props.row);

          return (
            <RowDragHandleCell rowId={props.row} isDraggable={props.row} />
          );
        },
      }),
      columnHelper.accessor("sequenceorder", {
        header: "Sequence",
        cell: (props) => {
          return <span>{props.row.original.sequenceorder}</span>;
        },
      }),

      columnHelper.accessor("articletitlename", {
        header: "Article Name",
        cell: ({ row, table }) => {
          const currentRow = row.original;
          const allRows = table.getRowModel().rows;
      
          // Get highest newsequence from moved articles
          const maxMovedSequence = Math.max(
            0,
            ...allRows
              .filter(r => r.original.is_moved_to_production === 'Yes')
              .map(r => Number(r.original.newsequence || 0))
          );
          
          let sequenceToUse: number;
      
          if (currentRow.is_moved_to_production === 'Yes' || !currentRow.articletitlename) {
            // Already moved → use newsequence
            sequenceToUse = Number(currentRow.newsequence);
          } else {
            // Not moved → need to find unmoved order
            const unmovedArticles = allRows.filter(r => r.original.is_moved_to_production !== 'Yes');
            const unmovedIndex = unmovedArticles.findIndex(r => r.id === row.id);
      
            sequenceToUse = maxMovedSequence + unmovedIndex + 1;
          }
      
          const indexFormatted = sequenceToUse.toString().padStart(2, "0");
      
          const articlename = `${journalPrefix ?? state?.journalPrefix}_${issueNumber ?? "defaultNumber"}_${editionInfo ?? "defaultEdition"}${indexFormatted}`;
      
          return (
            <span>
              {/* {currentRow.is_moved_to_production === 'Yes' ||!currentRow.articletitlename
                ? currentRow.articletitlename 
                : articlename} */}

              {currentRow.articletitlename?currentRow.articletitlename: articlename}
            </span>
          );
        },
      }),
      
      columnHelper.accessor("articlename", {
        header: "Article ID",
      }),
  
      columnHelper.accessor("articletitle", {
        header: "Title",
        cell: (info) => {
          const fullTitle = info.getValue();
          const words = fullTitle?.split(" ");
          const shortTitle = words?.slice(0, 3).join(" ") + (words?.length > 3 ? "..." : "");

          return <span title={fullTitle}>{shortTitle !== 'undefined' ? shortTitle : ' '}</span>;
        },
      }),
      columnHelper.accessor("articlecategory", {
        header: "Article Type",
        cell: ({ row }) => (
          // <ArticleTypeCell
          //   row={row}
          //   selectedValue={selectedValuesRef.current[row.index]}
          //   handleArticleTypeChange={handleArticleTypeChange}
          //   options={options}
          // />
          <span>{row?.original?.articletype}</span>
        ),
      }),
      columnHelper.accessor("moveddate", {
        header: "Created Date",
        cell: (props) => formatDate(props.getValue()),
      }),
      columnHelper.accessor("dueDate", {
        header: "Due Date",
        cell: (props) => formatDate(props.getValue()),
      }),
      columnHelper.accessor("is_moved_to_production", {
        header: "Move to Production Status",
      }),
      columnHelper.accessor("actions", {
        header: "Actions",
        cell: ({ row }) => {
          const rowData = row?.original;
          return (
            <>
              <button
                onClick={() => pdfDetails(rowData)}
                title="Download HTML Report"
                style={{ border: "none", background: "none" }}
              >
                <span className="material-symbols-outlined f-20">download</span>
              </button>
              <button
                onClick={async () => await handleMoveUnallocated(rowData)}
                title="Move to unallocated"
                className={
                  row.original.ismovedtoproduction ? "disabled-button" : ""
                }
                style={{ border: "none", background: "none" }}
                disabled={row.original.ismovedtoproduction}
              >
                <span className="material-symbols-outlined f-20">logout</span>
              </button>

              <button
                onClick={() => handleSupplement(rowData)}
                title="Supplement Files"
                style={{ border: "none", background: "none" }}
              >
                <span className="material-symbols-outlined f-20">
                  upload_file
                </span>
              </button>
              <button
                onClick={() => handleAddAuthor(rowData)}
                title="Add Author"
                style={{ border: "none", background: "none" }}
              >
                <span className="material-symbols-outlined f-20">person_add</span>
              </button>
            </>
          );
        },
      }),
    ];
  }, [
    editionInfo,
    issueNumber,
    journalPrefix,
    journalsvalue,
    isdisabled,
    issue,
    issuesvalue,
    assignee,
    state?.journalPrefix,
  ]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMsComplete(e.target.checked);
  };
console.log(allocatedtableData,)
  const unAllocatedColumns = useMemo(
    () => [
      // columnHelper.display({
      //   id: "drag",
      //   header: "",
      //   cell: (props) => (
      //     issuesvalue ? (
      //       <RowDragHandleCell rowId={props.row.id} />
      //     ) : null
      //   ),
      // }),
      // columnHelper.display({
      //   id: "drag",
      //   header: "",
      //   cell: (props) => <RowDragHandleCell rowId={props.row.id} />,
      // }),
      // columnHelper.accessor("articleid", {
      //   header: "Article ID"
      // }),
      columnHelper.accessor("articlename", {
        header: "Article ID",
      }),
      columnHelper.accessor("articletype", {
        header: "Article Type",
      }),
      columnHelper.accessor("createddate", {
        header: "Created Date",
        cell: (props) => formatDate(props.getValue()),
      }),
      columnHelper.accessor("actions", {
        header: "Actions",
        cell: (row: any) => {
          const rowData = row?.row?.original;
          return (
            <>
              <button
                onClick={() => handleMoveAllocated(rowData)}
                title="Move to Allocated"
                disabled={!issuesvalue}
                style={{ border: "none", background: "none" }}
              >
                <span className="material-symbols-outlined f-20">
                  arrow_upward
                </span>
              </button>
              <button
                onClick={() => pdfDetails(rowData)}
                title="Download HTML Report"
                style={{ border: "none", background: "none" }}
              >
                <span className="material-symbols-outlined f-20">download</span>
              </button>
            </>
          );
        },
      }),
    ],
    [issuesvalue]
  );

  const supplementColumns = [
    columnHelper.accessor("filename", {
      header: "Name",
    }),
    columnHelper.accessor("actions", {
      header: "Actions",
      cell: (row: any) => {
        const rowData = row?.row?.original;
        return (
          <>
            <button
              onClick={() => downloadSubblementary(rowData)}
              title="Download"
              style={{ border: "none", background: "none" }}
            >
              <span className="material-symbols-outlined f-20">download</span>
            </button>
            <button
              onClick={() => deletesublementoryfiles(rowData)}
              title="Move Allocated"
              style={{ border: "none", background: "none" }}
            >
              <span className="material-symbols-outlined f-20">delete</span>
            </button>
          </>
        );
      },
    }),
  ];

  // Function to add days to a date
  const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

const handleMoveAllocated = async (rowData: any) => {
  // Remove from Unallocated Lists
  setUnAllocatedTableData((prevData) =>
    prevData.filter((item: any) => item.id !== rowData.id)
  );
  setFilteredUnAllocatedTableData((prevData) =>
    prevData.filter((item: any) => item.id !== rowData.id)
  );

  // Convert Unallocated to Allocated Structure
  const mappedData = mapUnallocatedToAllocated(rowData);

  // Set Allocated Table Data
  setallocatedtableData((prevData: any) => {
    const newAllocatedData = [...prevData, mappedData];

    // Generate Unique Article Title Name
    let baseName =
      mappedData.articletitlename ||
      `${journalPrefix}_${issueNumber}_${editionInfo}`;

    const existingNames = newAllocatedData
      .filter((a) => a.articletitlename?.startsWith(baseName))
      .map((a) => a.articletitlename);

    if (existingNames?.length === 0) {
      baseName = `${baseName}01`;
    }

    let finalName = baseName;
    let maxNum = 0;

    existingNames.forEach((name) => {
      const suffix = name.replace(baseName, "");
      const match = suffix.match(/^(\d{2,})$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > maxNum) {
          maxNum = num;
        }
      }
    });

    if (maxNum > 0 || existingNames.length > 0) {
      const nextNum = maxNum + 1;
      finalName = `${baseName}${nextNum.toString().padStart(2, "0")}`;
    }

    // Apply calculated fields like sequence order, due date
    const updatedAllocatedData = newAllocatedData.map((item, index) => {
      const moveddate = new Date(item.moveddate);
      const dueDate = addDays(moveddate, 5);

      return {
        ...item,
        sequenceorder: index + 1,
        moveddate: !isNaN(moveddate.getTime())
          ? moveddate.toISOString().split("T")[0]
          : "Invalid Date",
        dueDate: !isNaN(dueDate.getTime())
          ? dueDate.toISOString().split("T")[0]
          : "Invalid Date",
        articletitlename: item.id === mappedData.id ? finalName : item.articletitlename,
      };
    });

    // Send only the newly moved article to backend
    const movedArticle = updatedAllocatedData.find((item) => item.id === mappedData.id);
    if (movedArticle) {
      const moveddate = new Date(movedArticle.moveddate);
      const dueDate = addDays(moveddate, 5);

      const transformedMappedData = {
        ...movedArticle,
        articleid: parseInt(movedArticle.articleid, 10),
        articletitlename: movedArticle.articletitlename,
        moveddate: !isNaN(moveddate.getTime())
          ? moveddate.toISOString().split("T")[0]
          : "Invalid Date",
        dueDate: !isNaN(dueDate.getTime())
          ? dueDate.toISOString().split("T")[0]
          : "Invalid Date",
      };

      saveIssueArticleDetails([transformedMappedData]);
      insertAuthorDetails(mappedData.articleid);
    }

    return updatedAllocatedData;
  });
};

  const insertAuthorDetails=async(articleid:any)=>{
     let url = apiUrl.nodeApi.getAuthorinfo;
           let payload = {
             articleid: articleid,
           };
           setIsLoader(true);
           console.log(payload, "payload");
           const response: any = await invokePostService(
             url,
             payload,
             props.isToken
           );
        
           if (!response.data.data.isSuccess)
             throw new Error(response.data.data.Error);
           const authorInfo = response.data.data.result[0];
          if(authorInfo){
            let payload = {
              ...authorInfo,
              createdby:props?.userInfo?.userid,
              emailid: authorInfo.email,
              authorname: authorInfo?.firstname + " " + authorInfo?.lastname,
              articleid: articleid || null,
              authortype: 1, // main author
              countryid: authorInfo?.country?.id,
              country: authorInfo?.country?.label,
            }
             const url = apiUrl.nodeApi.insertE2EAuthorInfo;
              const responses: any = await invokePostService(
                     url,
                     payload,
                     props.isToken
                   );
                   setIsLoader(false);
          }
  }



  const handleMoveUnallocated = async (rowData: any) => {
    setallocatedtableData((prevData: any) =>
      prevData.filter((item: any) => item.id !== rowData.id)
    );
    const mappedData = mapAllocatedToUnallocated(rowData);
    setUnAllocatedTableData((prevData): any => [...prevData, mappedData]);
    setFilteredUnAllocatedTableData((prevData): any => [
      ...prevData,
      mappedData,
    ]);
    try {
      let url = apiUrl.nodeApi.moveToUnAllocatedData;
      let payload = {
        id: rowData.id,
      };
      setIsLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setIsLoader(false);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      await getAllocatedList();
      await handleapprovedlist("unAllocatedTabledata");
    } catch (error) {
      toastError(`${error}`);
    }
  };

  const fetchAuthorDetails = async (articleId: any) => {
    try {
      let url = apiUrl.nodeApi.getAuthorByArticleId;
      const queryParams = { articleId: articleId };
      let response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );

      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }
      const data = response?.data?.data?.result;
      return data;
    } catch (error) {
      console.error("Error fetching author details of article!:", error);
      return null;
    }
  };

  const fetchSupplementFileDetails = async (articleid: any) => {
    try {
      let url = apiUrl.nodeApi.getSupplementFilesByArticleId;
      const payload = { articleid: articleid };
      let response: any = await invokePostService(url, payload, props.isToken);

      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }
      const data = response?.data?.data?.result;
      return data;
    } catch (error) {
      console.error("Error fetching author details of article!:", error);
      return null;
    }
  };

  const getAllocatedArticleCountByJournalidandIssueid = async () => {
    try {
      let url = apiUrl.nodeApi.getAllocatedArticleCountByJournalIdAndIssueId;
      const payload = {
        journalid: journalId || state.journalId,
        issueid: issueId || state.issueId,
      };

      let response: any = await invokePostService(url, payload, props.isToken);
      if (!response.data.data.isSuccess) {
        throw new Error(response.data.data.Error);
      }
      const data = response?.data?.data?.result;
      // localStorage.setItem("count", data[0].count);
      // setCount(parseInt(data[0].count));
      setRender(true);
      return data;
    } catch (error) {
      console.error("Error fetching author details of article!:", error);
      return null;
    } finally {
      setIsLoader(false);
    }
  };
  useEffect(() => {
    if (journalsvalue && issuesvalue) {
      getAllocatedArticleCountByJournalidandIssueid();
    }
  }, [journalsvalue, issuesvalue]);

  const handleSubmit = async () => {
    const saveDraftMessage = await handleDraft({
      isFromSubmit: true,
      showToast: false,
    });
    if (saveDraftMessage === "Error saving draft") {
      return;
    }

    try {
      setIsEtwoELoader(true);

      // Filtering out items where ismovedtoproduction is true
      const filteredData = allocatedtableData.filter(
        (item) => !item.ismovedtoproduction
      );
      if (!filteredData.length && !msComplete) {
        toastError('No articles available for allocation');
        return;
      }

      const uniqueArticleIds = [
        ...new Set(
          filteredData.map((item) => ({
            articleId: item.articleid,
            articleName: item.articlename,
          }))
        ),
      ];

      const authorDetailsPromises = uniqueArticleIds.map(
        async (article: any) => {
          try {
            const authorDetails = await fetchAuthorDetails(article.articleId);
            if (!authorDetails || authorDetails.length === 0) {
              throw new Error(
                `Missing author details for article ${article.articleName}, Add author details for each article and proceed to submit!`
              );
            } else {
              return { articleId: article?.articleId, authorDetails };
            }
          } catch (error) {
            throw error;
          }
        }
      );

      const supplementDetailsPromises = uniqueArticleIds.map(
        async (article: any) => {
          try {
            const supplementDetails = await fetchSupplementFileDetails(
              article.articleId
            );
            return { articleId: article?.articleId, supplementDetails };
          } catch (error) {
            console.error(
              `Error fetching supplement file details for articleId ${article.articleName}:`,
              error
            );
            return { articleId: article?.articleId, supplementDetails: null };
          }
        }
      );

      const authorDetailsResults = await Promise.all(authorDetailsPromises);
      const supplementDetailsResults = await Promise.all(
        supplementDetailsPromises
      );

      let transformedData = allocatedtableData.map((item) => {
        let extractedObject = {
          receivedDate: new Date(),
          articleId: item.articleid,
          articlecategory: item.articletype,
          // sequenceOrder: count + 1,
          sequenceOrder: item.sequenceorder,
          articleName: item.articletitlename,
          articleNameWithExtension:
            item.articletitlename + `.${item.filepath?.split(".")[1]}`,
          filePath: item.filepath,
          uploadedFileName: item.uploadedfilename,
          fileSize: item.filesize,
          uploadedBy: props?.userInfo?.email,
          authorDetails: [],
          supplementaryDetails: [],
        };

        const matchedAuthorDetails = authorDetailsResults.find(
          (result: any) => result?.articleId === item?.articleid
        );
        if (matchedAuthorDetails && matchedAuthorDetails.authorDetails) {
          const newAuthorDetails = matchedAuthorDetails.authorDetails.map(
            (author: any) => ({
              FirstName: author.firstname,
              LastName: author.lastname,
              AuthorName: `${author.firstname} ${author.lastname}`,
              Address: author.address,
              PostCode: author.postcode,
              City: author.city,
              Country: author.country,
              PhoneNumber: author.phonenumber,
              AuthorMailId: author.email,
            })
          );
          extractedObject.authorDetails = newAuthorDetails;
        } else {
          //toastError(``);
        }

        const matchedSupplementDetails = supplementDetailsResults.find(
          (result) => result.articleId === item.articleid
        );
        if (
          matchedSupplementDetails &&
          matchedSupplementDetails.supplementDetails
        ) {
          const newSupplementaryDetails =
            matchedSupplementDetails.supplementDetails.map(
              (supplement: any) => ({
                fileName: supplement.filename?.split(".")[0],
                filePath: supplement.filepath,
                fileSize: supplement.filesize,
                fileNameWithExtension: supplement.filename,
              })
            );
          extractedObject.supplementaryDetails = newSupplementaryDetails;
        }
        return extractedObject;
      });

      const url = apiUrl.nodeApi.postDataToE2E;
      const payload = {
        journalName: journalsvalue.value,
        receivedDate: new Date(),
        journalID: journalsvalue.id,
        isMsComplete: msComplete,
        issueName: issuesvalue.value,
        submittedBy: props?.userInfo?.email,
        articleDetails: transformedData,
      };
  
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      if (!response.data.data.result.isSuccess) {
        throw new Error(response.data.data.result.message);
      }
      toastSuccess("Data submitted to E2E system successfully!");
      //need refresh overall page
      handleRefresh();
      
    } catch (error) {
      toastError(`${error}`);
      handleRefresh();
    } finally {
      setIsEtwoELoader(false);
    }
  };

  const handleReset = () => {
    // Reset everything
    // setJournalsvalue("");
    // setJournalId("");
    // setIssuesvalue("");
    // setissueId("");
    // setIsShow1(false);
    // setallocatedtableData([]);
    // setUnAllocatedTableData([]);
    getAllocatedList();
  };
const handleRefresh =() =>{
   setJournalsvalue("");
    setJournalId("");
    setIssuesvalue("");
    setissueId("");
    setIssue([]);
    setIsShow1(false);
    setallocatedtableData([]);
    setUnAllocatedTableData([]);

}                                                                                                                                                                            
const handleDraft = async (config: any) => {
  try {

    if (allocatedtableData.length > 0) {
      console.log(allocatedtableData,"allocatedtableData");
      // ✅ Ensure sequenceorder is recalculated correctly
     const transformedAllocatedData = allocatedtableData.map((item, index) => {
  const base = `${journalPrefix || state?.journalPrefix}_${issueNumber || "00"}_${editionInfo || "XX"}`;
  const indexFormatted = (index + 1).toString().padStart(2, "0");
  const constructedName = `${base}${indexFormatted}`;

  return {
    ...item,
    sequenceorder: index + 1,
    articleid: parseInt(item.articleid),
    articletitlename: item.articletitlename || constructedName,  // ✅ fallback logic
  };
});

      console.log(transformedAllocatedData, "transformedAllocatedData")
      const saveDraftMessage = await saveIssueArticleDetails(
        transformedAllocatedData
      );
      if (
        saveDraftMessage == "Draft saved successfully" &&
        config.showToast
      ) {
        toastSuccess('Sequence saved successfully');
      }
      // setNewlyAllocatedArticles([]);
      return saveDraftMessage;
    } else if (config.isSubmitCall) {
      return "No new articles to save";
    } else {
      toastError(
        "Please move the unallocated article to the allocated articles section."
      );
      return "No articles to save";
    }
  } catch (error) {
    toastError("An error occurred while saving the draft.");
    return "Error saving draft";
  }
};



  const handleCloseInvite = () => {
    setFileName("");
    setFileData("");
    setExtention("");
    setOpenSupplement(!openSupplement);
    setUploadedFiles(new Map());
  };

  const handleSupplement = async (row: any) => {
    setAllocatedRowData(row);
    setOpenSupplement({ open: !openSupplement, row });
    await getsublementoryfiles(row?.articleid);
  };

  
  const handleAddAuthor = async (row: any) => {
    const currentState = {
      journalsvalue: journalsvalue,
      journalId: journalsvalue?.id,
      isdisabled: !isdisabled,
      issue: issue,
      issuesvalue: issuesvalue,
      issueId: issuesvalue?.id,
      assignee: assignee,
      journalPrefix: journalPrefix,
      issueNumber: issueNumber,
      editionInfo: editionInfo,
      ismovedtoproduction: row?.ismovedtoproduction,
    };
    if (allocatedtableData.length > 0) {
      const transformedAllocatedData = allocatedtableData.map((item: any) => ({
        ...item,
        articleid: parseInt(item.articleid),
      }));

      const saveDraftMessage = await saveIssueArticleDetails(
        transformedAllocatedData
      );
    }
    // Navigate to the '/addAuthor' route with state
    navigate("/addAuthor", {
      state: {
        row: row,
        currentState: currentState,
      },
    });
  };

  const removeFile = () => {
    if (fileName) {
      const baseFilename = fileName.slice(0, fileName.lastIndexOf("."))?.toLowerCase();
      setUploadedFiles(prev => {
        const newMap = new Map(prev);
        newMap.delete(baseFilename);
        return newMap;
      });
      setFileName("");
      setFileData("");
    }
  };

  const handleCancel = () => {
    setShowCancelModal(false);
  };

  const mapUnallocatedToAllocated = (unallocatedData: any) => {
    return {
      ...unallocatedData,
      moveddate: unallocatedData.createddate, // Map createddate to moveddate
    };
  };

  const mapAllocatedToUnallocated = (allocatedData: any) => {
    return {
      ...allocatedData,
      createddate: allocatedData.moveddate, // Map moveddate to createddate
    };
  };

  useEffect(() => {
    const lowercasedFilter = searchQuery?.toLowerCase();
    const filteredData = unAllocatedTableData.filter((item: any) =>
      item.articlename?.toLowerCase().includes(lowercasedFilter)
    );
    setFilteredUnAllocatedData(filteredData);
  }, [searchQuery, unAllocatedTableData]);

  useEffect(() => {
    setisdisabled(!(journalsvalue?.id || state?.journalsvalue?.id));
  }, [journalsvalue, state]);

  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}
      {isEtwoELoader && <WHSEtwoELoader></WHSEtwoELoader>}
      <Modal show={showModal} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete the file?</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCancel}>
            CANCEL
          </Button>
          <Button onClick={handleDelete}>DELETE</Button>
        </Modal.Footer>
      </Modal>
      <div className="page-title">
        <h3>Move article to production</h3>
        {/* <Button
          className="refresh-btn ml-2"
          variant="outline-secondary"
          onClick={handleReset}
        >
          Refresh
        </Button> */}
      </div>

      <div className="row">
        <div className="col-lg-3 col-md-12 col-sm-12 form-group">
          <label>Journal</label>
          <WMSSelect
            className="form-control f-14"
            placeHolder={"Select Journal"}
            options={journals}
            name="fileTypes"
            value={journalsvalue}
            isMulti={false}
            onChange={(e: any) => handleFormSelection(e, "journal")}
            id="fileTypes"
          />
        </div>
        <div className="col-lg-3 col-md-12 col-sm-12 form-group">
          <label>Volume(Issue)</label>
          <WMSSelect
            className="form-control f-14"
            placeHolder={"Select vol/issue"}
            options={issue}
            name="fileTypes"
            value={issuesvalue}
            disabled={isdisabled}
            isMulti={false}
            onChange={(e: any) => handleFormSelection(e, "issue")}
            id="fileTypes"
          />
        </div>
        <div className="col-lg-3 form-group">
          <label>Assign To</label>
          <WMSInput
            type="text"
            placeHolder="Enter assignee"
            className="form-control f-14"
            value={assignee}
            disabled={true}
            onChange={(e: any) => setAssignee(e.target.value)}
            id="assignTo"
          />
        </div>
        <Button
          onClick={handleRefresh}
          className="btn btn-primary refresh-btn ml-2"
          style={{ marginTop: "25px" }}
        >
          <span className="material-icons">refresh</span>
        </Button>
      </div>
      {isShow ? (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 style={{ alignItems: "center", display: "flex" }}>
              Allocated articles
            </h5>
            <div>

              <div className="d-flex justify-content-end align-items-center mb-3">
                <React.Fragment>
                  <WMSInput
                    type="checkbox"
                    name="msComplete"
                    className="cursor-pointer"
                    checked={isTableDisabled || msComplete}
                    onChange={handleCheckboxChange}
                    disabled={!allocatedtableData.length}
                  />
                  <span
                    className="ml-2"
                    style={{ fontSize: "15px", marginRight: "15px" }}
                  >
                    MS Complete
                  </span>
                </React.Fragment>
                <Button
                  onClick={() => handleDraft({ isFromSubmit: false, showToast: true })}
                  disabled={!allocatedtableData.length}
                  variant="outline-secondary"
                  className="me-3"
                >
                  Save Sequence
                </Button>

                <Button onClick={handleSubmit} className="me-3 ml-2">
                  Submit
                </Button>

                <Button onClick={handleReset} variant="outline-tertiary ml-2">
                  Reset
                </Button>
              </div>

            </div>
          </div>
          <div
          // style={{
          //   opacity: isTableDisabled ? 0.5 : 1,
          //   pointerEvents: isTableDisabled ? "none" : "auto",
          // }}
          >
            <DraggableComponent
              key={allocatedKey}
              columns={allocatedColumns}
              data={allocatedtableData}
              setData={setallocatedtableData}
              showPagination={false}
              journalPrefix={journalPrefix ?? state?.journalPrefix}   // Passing journalPrefix
              issueNumber={issueNumber ?? state?.issueNumber}       // Passing issueNumber
              editionInfo={editionInfo ?? state?.editionInfo}       // Passing editionInfo
            // disableTable={msComplete}
            />
          </div>
        </div>
      ) : (
        ""
      )}
      {isShow1 ? (
        <div className="mt-4">

          <h5>Unallocated articles</h5>
          <div className="row">
            <div className="col-lg-4 search-input">
              <WMSInput
                type="text"
                placeHolder="Search by article"
                className="form-control f-14"
                onChange={(e: any) => handlesearch(e)}
                id="unalocatedSearch"
              />
              <span className="material-icons">search</span>
            </div>
          </div>
          <div>
            <CustomTable
              // key={unallocatedKey}
              columns={unAllocatedColumns}
              data={filteredUnAllocatedTableData}
              showPagination={true}
              // disableTable={msComplete}
              // setData={setUnAllocatedTableData}
              isSearchable={false}
            />
          </div>
          {/* <div className="mb-5">
            <Button onClick={handleSubmit} className="mr-3">
              Submit
            </Button>

            <Button onClick={handleReset} variant="outline-tertiary">
              Reset
            </Button>
          </div> */}

          <Modal
            show={openSupplement.open}
            onShow={() => {
              setFileName("");
              setFileData("");
              setExtention("");
            }}
            onHide={handleCloseInvite}
            backdrop={"static"}
            style={{ height: "500px" }}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Supplement Files</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: "100px" }}>
              {!openSupplement?.row?.ismovedtoproduction && (
                <div
                  className="row"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="col-lg-8 form-group">
                    <label>
                      File Upload
                      <span
                        className="material-icons file-note cursor-pointer"
                        onClick={() => setFileTipShow(!fileTipShow)}
                      >
                        info
                      </span>
                    </label>
                    {fileTipShow ? (
                      <div className="file-tip">
                        <p>
                          Accepted formats: {allowedFileTypes.join(", ")}. Max
                          size: 50 MB.
                        </p>
                      </div>
                    ) : null}
                    <div className="file-upload">
                      <p>Drag and drop files</p>
                      <input
                        type="file"
                        placeholder="Upload"
                        accept={allowedFileTypes.join(",")}
                        onChange={(e: any) => {
                          uploadFile(e, "file", true);
                        }}
                        // multiple
                        ref={fileInputRef}
                      />
                      <div className="browser-text">
                        <span className="material-icons">upload</span> Browse
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 form-group fileUpload">
                    <Button
                      variant="primary"
                      title="Upload"
                      onClick={() => {
                        try {
                          uploadArticle();
                          // setOpenSupplement({ open: false, row: null }); // Optionally close modal
                          setFileName("");
                          setFileData("");
                          setExtention("");
                        } catch (error) { }
                      }}
                      disabled={!fileData}
                    >
                      Upload
                    </Button>
                  </div>
                </div>
              )}

              {fileName ? (
                <div className="col-md-12 attachment-list">
                  <p title={fileName}>
                    {fileName}
                    <i
                      className="bi bi-trash ml-2"
                      style={{ cursor: "pointer" }}
                      title="Delete"
                      onClick={() => {
                        removeFile();
                      }}
                    ></i>{" "}
                  </p>
                </div>
              ) : (
                ""
              )}

              <div className="row">
                <div className="col-lg-12 form-group">
                  <div className="tableoverflowHead">
                    <CustomTable
                      columns={supplementColumns}
                      data={sublementtableData}
                      showPagination={false}
                      isSearchable={false}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,
    // isFileUpload:state.rootReducer.articleReducer.fileUpload
  };
};

export default connect(mapStateToProps, null)(HOCAutoLogout(MoveArticle));
